<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="add_fa">
        <button class="close_bt" @click="closeDialog"></button>
        <span class="s_pop_title">로그인</span>
        <v-text-field solo label="테스트 사용자 ID" v-model="email">
        </v-text-field>
        <v-text-field
          solo
          label="비밀번호를 입력하세요"
          type="password"
          v-model="password"
          v-on:keyup.enter="login()"
        >
        </v-text-field>
        <div class="danger-alert" v-if="error">
          {{ error }}
        </div>
        <div class="btnArea">
          <button type="submit" class="btn type3" @click="login">로그인</button>
          <button type="submit" class="btn type3 reset" @click="closeDialog">
            취소
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
// import crypto from 'crypto-js';

export default {
  components: {},
  props: ['dialog', 'closeDialog'],
  data() {
    return {
      loading: true,
      error: null,
      email: '',
      password: '',
    };
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    init() {
      this.error = null;
      this.email = '';
      this.password = '';
    },
    close() {
      this.init();
      this.closeDialog();
    },
    async getSettings() {
      await this.$http
        .get('/api/v1/systems')
        .then((response) => {
          this.settings = response.data;
          if (this.settings === '' || this.settings === null) {
            this.settings = Object.assign({}, this.defaultSettings);
          }
          this.$store.dispatch('setSettings', this.settings);
        })
        .catch((error) => {
          this.$store.dispatch('setSettings', this.defaultSettings);
        });
    },
    async login() {
      if (this.email === '' || this.email === null) {
        this.error = '이메일이 입력되지 않았습니다.';
        return;
      }

      if (this.password === '' || this.password === null) {
        this.error = '비밀번호가 입력되지 않았습니다.';
        return;
      }

      // 임시 로그인 팝업이기 때문에 crypto-js 생략하고 그냥 email / password 넘김
      // let email = crypto.AES.encrypt(this.email, 'password123!').toString();
      // let password = crypto.AES.encrypt(this.password, 'password123!').toString();
      this.$http
        .post('/api/auth/login', { email: this.email, password: this.password })
        .then((response) => {
          if (response.data.user.status === 'r') {
            window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
            this.loading = false;
            return;
          }
          this.loginSuccess(response);
        })
        .catch((error) => {
          this.loading = false;
          this.error = error.response.data.error;
        });
    },
    async loginSuccess(response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 600000);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;

      await this.$http
        .post('/api/auth/login/log')
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
          // this.error = error.response.data.error;
        });
      await this.getSettings();
      const isAdmin = (await this.$http.get('/api/auth/check/admin/server'))
        .data;
      setTimeout(() => {
        if (isAdmin === true) {
          this.$router.replace('/dashboard');
        } else {
          this.$router.replace('/sMeeting');
        }
        this.loading = false;
      }, 500);

      // setTimeout(() => {
      //   this.$router.replace('/kMeeting');
      //   this.loading = false;
      // }, 500);
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/popup/LoginTestDialog.vue